import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';

const ButtonSection = ({
  editEnable,
  loading,
  classNameModify,
  labelRecomendation,
  labelRequired,
  labelModify,
  labelCancel,
  labelSave,
  onSave,
  onToggle,
}) => (
  <div className="col-xs-12 btn-section">
    <div className="col-md-6 col-sm-12 col-xs-12">
      <div className="texto-gris padding-top-05 pull-left">
        <p>{editEnable ? labelRequired : labelRecomendation}</p>
      </div>
    </div>
    <div className="col-md-6 col-sm-12 col-xs-12">
      <div className={`col-sm-offset-4 col-sm-4 col-xs-12  ${classNameModify}`}>
        <button
          type="button"
          className="btn btn-default btn-block margin-top-05"
          onClick={onToggle}
        >
          {editEnable ? labelCancel : labelModify}
        </button>
      </div>
      {editEnable && (
        <div className="col-sm-4 col-xs-12">
          {loading ? (
            <Loader active={loading} className="btn-block margin-top-05" />
          ) : (
            <button
              type="button"
              className="btn btn-primary btn-block margin-top-05"
              onClick={onSave}
            >
              {labelSave}
            </button>
          )}
        </div>
      )}
    </div>
  </div>
);

ButtonSection.propTypes = {
  editEnable: PropTypes.bool,
  loading: PropTypes.bool,
  classNameModify: PropTypes.string,
  labelRecomendation: PropTypes.string,
  labelRequired: PropTypes.string,
  labelModify: PropTypes.string,
  labelCancel: PropTypes.string,
  labelSave: PropTypes.string,
  onSave: PropTypes.func,
  onToggle: PropTypes.func,
};

export default ButtonSection;
